import { SAVE_RECORDINGS, CLEAR_RECORDINGS } from '../types/recordings';

export const initialState = {
  files: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SAVE_RECORDINGS:
      return { ...state, files: action.payload };
    case CLEAR_RECORDINGS:
      return { ...state, files: [] };
    default:
      return state;
  }
};
